/**
 * This is the entry point for the frontend specific JS of the block.
 *
 * Here you can initialize any necessary JS that should only run in the frontend.
 */
import InitCourses from './frontend/initCourses';

document.addEventListener(
	'DOMContentLoaded', () => {
		InitCourses.initAll();
	}
);
